import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { useVibe } from "./VibeLayout";
import { FeedList } from "./VideoSlide";

const TABS = [["foryou", "For You"], ["following", "Following"], ["trending", "Trending"], ["challenges", "Challenges"], ["new", "New Creators"]];

export default function VibeFeed() {
  const [tab, setTab] = useState("foryou");
  const { me } = useVibe();
  const nav = useNavigate();
  return (
    <div className="h-full relative" data-testid="vibe-home">
      <div className="absolute top-0 inset-x-0 z-20 pt-3 pb-6 bg-gradient-to-b from-black/60 to-transparent flex items-center">
        <button onClick={() => nav("/browse")} className="pl-3 pr-1 text-xs mono text-white/70 shrink-0" data-testid="vibe-back">←</button>
        <div className="flex-1 flex gap-4 overflow-x-auto px-3 [scrollbar-width:none]">
          {TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} data-testid={`vibe-tab-${k}`} className={`shrink-0 text-[15px] font-bold pb-1 transition-colors ${tab === k ? "text-white border-b-2 border-white" : "text-white/55"}`}>{l}</button>)}
        </div>
        <button onClick={() => nav("/vibe/discover")} aria-label="Search" className="px-3 shrink-0" data-testid="vibe-search-btn"><Search className="w-5 h-5" /></button>
      </div>
      <FeedList deps={[tab, !!me]} load={(skip) => api.get("/vibe/feed", { params: { tab, skip } }).then((r) => r.data)}
        empty={tab === "following" ? (me ? "Follow creators to fill this feed." : "Sign in to see videos from creators you follow.") : "No videos yet — tap + to post the first one!"} />
    </div>
  );
}
